// Single source of truth for surfacing backend error messages to users.
// Prefer FastAPI's `detail` field (string) — fall back to caller-supplied copy,
// then to a generic message. Keeps toast strings consistent across the app.
export function getErrorMessage(err, fallback) {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string" && detail.trim()) return detail;
  // FastAPI sometimes returns `detail` as an array of validation issues — pick the first msg.
  if (Array.isArray(detail) && detail[0]?.msg) return detail[0].msg;
  // Typed FastAPI errors carry operator-facing text in detail.message.
  // Return only nonempty strings, never stringify a payload or nested object.
  if (detail && !Array.isArray(detail)
      && typeof detail.message === "string" && detail.message.trim()) {
    return detail.message;
  }
  return fallback || "Something went wrong";
}
